import React, {useEffect, useState} from 'react';
import { Card, Table, Badge, Dropdown, Pagination } from 'react-bootstrap';
import {authService} from "../../services/authService";
import NotificationService from "../../services/NotificationService";
import {userService} from "../../services/userService";
import {businessYearService} from "../../services/businessYearService";
import eventEmitter from "../../shared/eventEmitter";
import {EventEmitterTypes} from "../../shared/eventEmitterEnum";
import {useNavigate} from "react-router-dom";
import MaxDailyValueModal from "./modals/MaxDailyValueModal";
import {CustomToggle} from "../../shared/components/CustomYearlySettingsToggleOptions";




export interface Settings {
    created: Date,
    current: boolean,
    maximumWorkAmountPerDay: number,
    webPriceAdjustmentAmount: number,
    scheduleEndDate: string,
    scheduleStartDate: string,
    year: number
}

interface YearlySettingsDetailsProps {
    details: Settings;
}



const MaxDailyValueCard: React.FC<YearlySettingsDetailsProps> = ({details}) => {
    const [showModal, setShowModal] = useState(false);
    const [maxAmount, setMaxAmount] = useState(0);
    const [startDate, setStartDate] = useState<string>(null);
    const [endDate, setEndDate] = useState<string>(null);
    useEffect(() => {
        const refreshListener = () => {
            businessYearService.getBusinessYear(details.year).then(res => {
                setMaxAmount(res.maximumWorkAmountPerDay);
                setStartDate(res.scheduleStartDate);
                setEndDate(res.scheduleEndDate);
            });
        };

        eventEmitter.on(EventEmitterTypes.REFRESH_LOADED_YEAR_MAX_DAILY, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_LOADED_YEAR_MAX_DAILY, refreshListener);
        };
    }, []);

    useEffect(() => {
        if(details) {
            setMaxAmount(details.maximumWorkAmountPerDay)
            setStartDate(details.scheduleStartDate);
            setEndDate(details.scheduleEndDate);
        }
    }, [details]);
    return (
        <>
        <div className="card yearlySettingsCard">
            <div className="cardHeader">
                <h2 className="">
                                            <span className="cuteIcon yellow">
                                                <i className="fa-solid fa-gauge-max"></i>
                                            </span>
                    Max Daily Value
                </h2>
                <div className="cardAction">
                    <Dropdown style={{display: 'flex', justifyContent: 'flex-end'}} align="end"
                              className="text-end">
                        <Dropdown.Toggle as={CustomToggle} id="priceSqFtBtn">
                            <i className="fa-solid fa-ellipsis"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setShowModal(true);
                                }}
                            >
                                <i className="fa-light fa-pencil fa-fw"></i> Edit
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className="cardBody">
                <h3 className="chonky">
                    {maxAmount}
                </h3>
            </div>
        </div>
            <MaxDailyValueModal year={details.year} webPriceAdjustmentAmount={details.webPriceAdjustmentAmount} startDateProp={startDate} endDateProp={endDate} show={showModal} toggle={() => setShowModal(false)} MaximumWorkAmountPerDay={maxAmount}/>
        </>
    );
};

export default MaxDailyValueCard;
